"use strict";

/**
 * Start-End Date/DateTime field component
 */
angular.module("core")
.component("startEndDateTime", {
    templateUrl: require("./start-end-date-time.component.html"),
    controller: StartEndDateTimeController,
    bindings: {
        startDateModel: "=",
        endDateModel: "=",
        formName: "<",
        submitFlag: "<",
        required : "<",
        startDateLabel: "<?",
        endDateLabel: "<?",
        fromToday: "<?",
        dateOnly: "<?"
    }
});

function StartEndDateTimeController($scope, $controller) {
    angular.extend(this, $controller("abstractStartEndDateTimeController", {$scope: $scope, dateOnly: this.dateOnly}));

    if (this.fromToday) {
        var today = moment();
        $scope.startDateOptions.minDate = this.getBeginningOfTheDay(today);
        $scope.endDateOptions.minDate = this.getBeginningOfTheDay(today);
    }
}



//////////////////
// WEBPACK FOOTER
// ./core/start-end-date/start-end-date-time.component.js
// module id = 536
// module chunks = 0